import type { PublicShop } from "@fusiqo/vozqi-shared";
import { TodayLine, TradeLine } from "./profile-hero";
import { RowChevron } from "./row-chevron";

/**
 * WHOSE ITEM THIS IS: the business's trade in its zone and whether it is
 * open right now, at the foot of the item's panel, the whole row one link
 * back to the profile. The logo and the name are in the bar above; a second
 * bar under it would read as a double menu.
 */
export function ItemBusiness({ shop, href }: { shop: PublicShop; href: string }) {
  const { profile } = shop;
  return (
    <a className="item-business" href={href}>
      <div className="item-business-text">
        <TradeLine trade={profile.trade} zone={profile.zone} />
        <TodayLine profile={profile} />
      </div>
      <RowChevron className="item-business-chevron" size={20} />
    </a>
  );
}
